<template>
  <div class="app-header">
    
    <!-- Container Balon -->
    <div class="balloon-container">
      <div
        v-for="balloon in balloons"
        :key="balloon.id"
        class="balloon"
        :style="{
          left: balloon.left || '0%',
          width: balloon.size + 'px',
          height: balloon.size + 'px',
          backgroundColor: balloon.color,
          animationDuration: balloon.duration,
          animationDelay: balloon.delay
        }"
      ></div>
    </div>

    <!-- Logo -->
    <div class="logo">
      <router-link to="/">
        <!-- Saya ganti ke tag img biasa, pastikan path benar -->
        <img src="@/assets/pcu/2026/logo-petraparade-header.png" alt="Logo">
      </router-link>
    </div>

  </div>
</template>

<script>
export default { 
  name: 'AppHeader',

  data() {
    return {
      balloonCount: 8, // reduced from 30 — 30 animated inset-shadow elements killed iOS Safari
      colors: ['#DF654D', '#F0D25B', '#78BE95', '#4489C6', '#D6ACCC'],
      balloons: []
    }
  },

  created() {
    this.generateBalloons()
  },

  methods: {
    generateBalloons() {
      const balloons = []
      const shuffledColors = this.shuffleArray([...this.colors])

      // 👉 lebar tiap segment biar merata
      const segmentWidth = 100 / this.balloonCount

      for (let i = 0; i < this.balloonCount; i++) {
        const color = shuffledColors[i % this.colors.length]

        // 👉 posisi dasar (dibagi rata)
        const base = i * segmentWidth

        // 👉 sedikit random biar natural (tidak kaku)
        const offset = this.randomFloat(-segmentWidth / 3, segmentWidth / 3)

        // 👉 clamp supaya tetap di 0–100%
        const left = Math.min(100, Math.max(0, base + offset))

        balloons.push({
          id: i + 1,
          left: `${left}%`,
          size: this.random(16, 26),
          color: color,
          delay: `-${this.random(0, 8)}s`,
          duration: `${this.random(9, 15)}s`
        })
      }

      this.balloons = balloons
    },

    // 👉 random integer
    random(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },

    // 👉 random float (biar offset lebih halus)
    randomFloat(min, max) {
      return Math.random() * (max - min) + min
    },

    // 👉 shuffle warna biar tidak urut terus
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[array[i], array[j]] = [array[j], array[i]]
      }
      return array
    }
  }
}
</script>

<style scoped>
.app-header {
  position: relative;
  width: 100%;
  height: 95px; /* TENTUKAN TINGGI HEADER */
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  overflow: hidden; /* Balon akan terpotong di batas header ini */
}

.balloon-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1; /* Pastikan di atas background tapi di bawah logo */
  contain: layout paint; /* Prevent layout/paint cascade to parent */
}

.logo {
  position: relative;
  z-index: 10; /* Logo harus paling depan */
}

.logo img {
  height: 80px;
  display: block;
}

/* STYLE BALON */
.balloon {
  position: absolute;
  bottom: -60px; /* Mulai dari luar bawah header */
  border-radius: 50%;
  opacity: 0.8;
  animation-name: rise;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  /* Removed inset box-shadow — prevents GPU layer promotion on iOS Safari */
  will-change: transform; /* Promote each balloon to its own compositing layer */
}

/* Buntut Balon */
.balloon::before {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 6px solid var(--bc);
}

/* Animasi Terbang — use translate3d for GPU compositing on iOS Safari */
@keyframes rise {
  0% {
    transform: translate3d(0, 0, 0) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 0.8;
  }
  50% {
    transform: translate3d(0, -100px, 0) rotate(10deg);
  }
  100% {
    transform: translate3d(0, -200px, 0) rotate(-10deg);
    opacity: 0;
  }
}
</style>